module.exports = {"361027100":"秀谷镇","361027101":"浒湾镇","361027102":"双塘镇","361027103":"何源镇","361027104":"合市镇","361027105":"琅琚镇","361027106":"左坊镇","361027107":"对桥镇","361027200":"黄通乡","361027202":"陆坊乡","361027203":"陈坊积乡","361027204":"琉璃乡","361027205":"石门乡","361027400":"华侨管理区","361027401":"江西金溪工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361027.json
// module id = 1335
// module chunks = 0